import img1 from "../assets/gallery/Kyrgyzstan/kyrgyzstan1.webp";
import img2 from "../assets/gallery/Kyrgyzstan/kyrgyzstan2.webp";
import img3 from "../assets/gallery/Kyrgyzstan/kyrgyzstan3.webp";
import img4 from "../assets/gallery/Kyrgyzstan/kyrgyzstan4.webp";
import img5 from "../assets/gallery/Kyrgyzstan/kyrgyzstan5.webp";
import img6 from "../assets/gallery/Kyrgyzstan/kyrgyzstan6.webp";
import img7 from "../assets/gallery/Kyrgyzstan/kyrgyzstan7.webp";
import img8 from "../assets/gallery/Kyrgyzstan/kyrgyzstan8.webp";
import img9 from "../assets/gallery/Kyrgyzstan/kyrgyzstan9.webp";

const kyrgyzstanGallery = [
  { img: img1, rowSpan: 2 }, // tall image
  { img: img2 },
  { img: img3 },

  { img: img4, colSpan: 2 }, // wide image
  { img: img5 },

  { img: img6 },
  { img: img7, rowSpan: 2 }, // tall image

  { img: img8 },
  { img: img9 },
];

export default kyrgyzstanGallery;
